<template>
  <div class="release_need">
    <LsLayout type="vertical">
      <div class="container">
        <div class="banner hidden-xs">
          <div class="banner-bg top"></div>
          <div class="banner-bg bot"></div>
          <h3 class="banner-title">
            数据蜂电话调查众包平台，专业的执行团队，优质的数据采集，一站式的调研服务
          </h3>
          <div class="step-list">
            <div class="step">
              <img src="../assets/images/step-01.png" />
              <div>
                <div class="step-title">发布需求</div>
                <div class="step-desc">免费登记项目需求</div>
              </div>
            </div>
            <div class="arrow"></div>
            <div class="step">
              <img src="../assets/images/step-02.png" />
              <div>
                <div class="step-title">签订合同</div>
                <div class="step-desc">极速对接项目落地</div>
              </div>
            </div>
            <div class="arrow"></div>
            <div class="step">
              <img src="../assets/images/step-03.png" />
              <div>
                <div class="step-title">项目实施</div>
                <div class="step-desc">执行电话调查</div>
              </div>
            </div>
            <div class="arrow"></div>
            <div class="step">
              <img src="../assets/images/step-04.png" />
              <div style="margin-left:-10px">
                <div class="step-title">验收交付</div>
                <div class="step-desc">客户获得高质量数据</div>
              </div>
            </div>
          </div>
        </div>
        <div class="main">
          <div class="slide">
            <div class="slide-nav" v-if="isLogin">
              <div class="slide-nav-item" v-for="(item, index) in navList"
                :class="{ 'slide-nav-active': navActive == item.value }" @click="handleNavClick(item.value)">
                {{ item.name }}</div>
            </div>
            <div class="slide-button" @click="$router.push({ path: '/login' })" v-else>
              客户登录＞</div>
          </div>
          <div class="content">
            <LsPanel :title="handleType == 'release' || showResult ? '发布需求' : '需求信息'"
              v-if="navActive == '01' || handleType == 'detail'">
              <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="160px" class="panel-form"
                v-if="!showResult" hide-required-asterisk>
                <template v-if="handleType == 'edit' || handleType == 'release'">
                  <el-form-item prop="name" label="项目名称：">
                    <el-input v-model="ruleForm.name" placeholder="请输入项目名称"></el-input>
                  </el-form-item>
                  <el-form-item prop="describe" label="项目介绍：">
                    <el-input v-model="ruleForm.describe" type="textarea" :rows="5" placeholder="请输入您项目的介绍，请尽可能详细一些"
                      maxlength="300" show-word-limit>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="num" label="期望回收问卷份数：">
                    <el-input v-model="ruleForm.num" placeholder="请输入期望回收的问卷份数">
                      <template slot="append">份</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="imgs" label="上传项目相关资料：">
                    <LsUpload v-model="ruleForm.imgs" ref="uploader"></LsUpload>
                  </el-form-item>
                  <el-form-item prop="phone" label="问卷设计：">
                    <el-row :gutter="10" class="card-row">
                      <template v-for="(item, index) in designList">
                        <el-col :md="12" :xs="24">
                          <div class="radio-card" :class="{ 'radio-card-active': ruleForm.is_design == item.value }"
                            @click="ruleForm.is_design = item.value">
                            <div class="radio-card-title">{{ item.name }}</div>
                            <div class="radio-card-body">{{ item.content }}</div>
                          </div>
                        </el-col>
                      </template>
                    </el-row>
                  </el-form-item>
                  <el-form-item prop="phone" label="调查样本：">
                    <el-row :gutter="10" class="card-row">
                      <template v-for="(item, index) in surveyList">
                        <el-col :md="12" :xs="24">
                          <div class="radio-card"
                            :class="{ 'radio-card-active': ruleForm.is_survey_sample == item.value }"
                            @click="ruleForm.is_survey_sample = item.value">
                            <div class="radio-card-title">{{ item.name }}</div>
                            <div class="radio-card-body">{{ item.content }}</div>
                          </div>
                        </el-col>
                      </template>
                    </el-row>
                  </el-form-item>

                </template>


                <template v-if="handleType == 'detail'">
                  <el-form-item prop="name" label="项目名称：">
                    <div class="form-item-detail">{{ ruleForm.name }}</div>
                  </el-form-item>
                  <el-form-item prop="describe" label="项目介绍：">
                    <div class="form-item-detail">{{ ruleForm.describe }}</div>
                  </el-form-item>
                  <el-form-item prop="num" label="期望回收问卷份数：">
                    <div class="form-item-detail">{{ ruleForm.num }}份</div>
                  </el-form-item>
                  <el-form-item prop="imgs" label="上传项目相关资料：">
                    <LsUpload v-model="ruleForm.imgs" disabled></LsUpload>
                  </el-form-item>
                  <el-form-item prop="name" label="问卷设计：">
                    <el-row :gutter="10" class="card-row">
                      <template v-for="item in designList">
                        <el-col :md="12" :xs="24">
                          <div class="radio-card" v-if="ruleForm.is_design == item.value">
                            <div class="radio-card-title">{{ item.name }}</div>
                            <div class="radio-card-body">{{ item.content }}</div>
                          </div>
                        </el-col>
                      </template>
                    </el-row>
                  </el-form-item>
                  <el-form-item prop="name" label="调查样本：">
                    <el-row :gutter="10" class="card-row">
                      <template v-for="item in surveyList">
                        <el-col :md="12" :xs="24">
                          <div class="radio-card" v-if="ruleForm.is_survey_sample == item.value">
                            <div class="radio-card-title">{{ item.name }}</div>
                            <div class="radio-card-body">{{ item.content }}</div>
                          </div>
                        </el-col>
                      </template>
                    </el-row>
                  </el-form-item>
                </template>

                <el-form-item>
                  <div class="form-btn-groups">
                    <el-button type="custom" class="form-btn edit-btn" @click="handleEdit" v-if="showEditBtn">
                      编辑
                    </el-button>
                    <el-button type="custom" class="form-btn" @click="handleConfirm" v-if="showConfirmBtn">
                      确认
                    </el-button>

                    <el-button type="custom" class="form-btn" @click="handleSubmit" v-if="showReleaseBtn">
                      发布
                    </el-button>
                  </div>
                </el-form-item>
              </el-form>

              <div class="release-success" v-if="showResult">
                <img src="../assets/images/release-success.png" />
                <div class="title">发布成功</div>
                <p>我们将会在3个工作日内电话联系您的手机号：{{ userinfo.username }}，请您注意接听</p>
              </div>

            </LsPanel>
            <LsPanel title="我的需求" v-if="navActive == '02' && handleType != 'detail'">
              <LsTable :data="tableData" @edit="handleNeed"></LsTable>
            </LsPanel>
          </div>
        </div>
      </div>
    </LsLayout>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="360px" class="ls-dialog" center>
      <img src="../assets/images/tips.png" class="tips-img" />
      <div class="tips-text text-center">请选择提交方式?</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleToReleasePath('/register')">注册账号提交</el-button>
        <el-button type="primary" @click="handleToReleasePath('/login?active=02')">手机验证码提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    var numReg = /^(?:[1-9]\d*)$/
    var validateNum = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入期望回收的问卷份数'));
      } else if (!numReg.test(value)) {
        callback(new Error('期望回收问卷份数必须为数字'));
      } else if (value.length > 9) {
        callback(new Error('期望回收问卷份数不能超过9位数'));
      } else {
        callback();
      }
    };
    return {
      navActive: "01",
      ruleForm: {
        is_design: 1,
        is_survey_sample: 1,
      },
      rules: {
        name: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
          { max: 100, message: '项目名称不能多于100个字符', trigger: 'blur' }
        ],
        describe: [
          { required: true, message: "请输入项目介绍", trigger: "blur" }
        ],
        num: [
          { validator: validateNum, trigger: "blur" }
        ],
      },
      designList: [
        { name: "需要设计问卷", value: 1, content: "没有完整的问卷或不确定问卷内容是否能达到调查目的，需要专家设计问卷内容。" },
        { name: "无需设计问卷", value: 0, content: "已有完整的符合调查目的的问卷，按此问卷题目开展调查。" }
      ],
      surveyList: [
        { name: "需要样本服务", value: 1, content: "没有调查样本，需要专家设计抽样方案并提供样本。" },
        { name: "无需样本服务", value: 0, content: "已有调查样本，且数量满足调查有效样本量需求。" }
      ],
      navList: [
        { name: '发布新需求', value: '01' },
        { name: '我的需求', value: '02' }
      ],
      isLogin: false,
      need_id: "",
      tableData: [],
      handleType: 'release', //edit:编辑 detail:查看 release:发布
      showEditBtn: false,
      showReleaseBtn: false,
      showConfirmBtn: false,
      userinfo: {},
      showResult: false,

      dialogVisible: false,
      unReleaseNeedId: '',//未发布的需求
    };
  },
  computed: {},
  watch: {
    navActive (v) {
      this.showResult = false
    }
  },
  mounted () {
    const userinfo = sessionStorage.getItem("userinfo") || undefined;
    if (userinfo) {
      this.userinfo = JSON.parse(userinfo)
      this.isLogin = true
      this.handleGetNeedList()
      this.showConfirmBtn = true
      this.showReleaseBtn = false
      this.showEditBtn = false
    } else {
      this.showReleaseBtn = true
    }

    // 查看是否有登录前已提交未发布的需求
    const unReleaseNeedId = sessionStorage.getItem('unReleaseNeedId') || undefined
    if (unReleaseNeedId) {
      if (this.isLogin) this.handleBindNeed(unReleaseNeedId)
      else this.handleGetNeedInfo(unReleaseNeedId)
    }
  },
  methods: {

    handleGetPanleTitle () {

    },
    /**
     * 
     * @param {*} path
     * @return {*}
     */
    handleToReleasePath (path) {
      this.$router.push(path)
      this.dialogVisible = false
    },
    /**
     * 绑定未发布的需求
     * @param {*} need_id
     * @return {*}
     */
    handleBindNeed (need_id) {
      this.$post(`/ajaxApi/index.php?s=Client.IntentClient.BindNeed`, { need_id }, (data, status, msg) => {
        this.handleGetNeedInfo(need_id);
        this.showReleaseBtn = true
        this.showConfirmBtn = false
        this.showEditBtn = true
        this.handleType = 'detail'
      })
    },
    /**
     * nav click
     * @param {*} v
     * @return {*}
     */
    handleNavClick (v) {
      this.navActive = v
      this.handleType = 'edit'
      this.showConfirmBtn = true
      this.showEditBtn = false
      this.showReleaseBtn = false
      this.showResult = false
      this.handleResetForm()
    },
    /**
     * 重置表单
     * @return {*}
     */
    handleResetForm () {
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields()
      }
      this.ruleForm = {
        is_design: 1,
        is_survey_sample: 1
      }
    },
    /**
     * 切换编辑 
     * @return {*}
     */
    handleEdit () {
      this.handleType = 'edit'
      this.showEditBtn = false
      this.showReleaseBtn = false
      this.showConfirmBtn = true
    },
    /**
     *  
     * @param {*} records
     * @return {*}
     */
    handleNeed (records) {
      const { id, type } = records
      this.handleGetNeedInfo(id)

      switch (type) {
        case 'release':
          this.navActive = '01'
          this.handleType = 'detail'
          this.showEditBtn = true
          this.showConfirmBtn = true
          this.showReleaseBtn = false
          break;
        case 'edit':
          this.navActive = '01'
          this.handleType = 'edit'
          this.showEditBtn = false
          this.showConfirmBtn = true
          this.showReleaseBtn = false
          break;
        case 'detail':
          this.navActive = '02'
          this.handleType = 'detail'
          this.showEditBtn = false
          this.showReleaseBtn = false
          this.showConfirmBtn = false
          break;
        default:
          break;
      }

    },

    /**
     * 发布需求
     * @param {*} need_id
     * @return {*}
     */
    handleReleaseNeed (need_id) {
      this.$post(`/ajaxApi/index.php?s=Client.IntentClient.ReleaseNeed`, { need_id }, (data, status, msg) => {
        if (status) {
          this.handleGetNeedList()
        } else {
          this.$message.error(msg);
        }
      })
    },
    /**
     * 需求列表
     * @return {*}
     */
    handleGetNeedList () {
      this.$post(`/ajaxApi/index.php?s=Client.IntentClient.NeedList`, {}, (data, status, msg) => {
        if (status) {
          this.tableData = data.list || []
        } else {
          this.$message.error(msg);
        }
      })
    },
    handleConfirm () {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.showConfirmBtn = false
          this.showReleaseBtn = true
          this.showEditBtn = true
          this.handleType = 'detail'
        }
      })
    },
    /**
     * 提交表单
     * @return {*}
     */
    handleSubmit () {

      this.$refs["ruleForm"].validate(valid => {
        if (valid) {

          if (this.$refs.uploader && this.$refs.uploader.status == 'pending') {
            return this.$message.error('文件正在上传中！')
          }

          const { imgs } = this.ruleForm

          const _param = {
            ...this.ruleForm,
            imgs: JSON.stringify(imgs),
            status: this.isLogin ? 1 : 0
          }

          let uri = `/ajaxApi/index.php?s=Client.IntentClient.AddNeed`;
          if (_param.need_id) {
            uri = '/ajaxApi/index.php?s=Client.IntentClient.EditNeed'
          }

          this.$post(uri, _param, (data, status, msg) => {
            if (status) {
              this.isConfirm = true
              if (this.isLogin) {
                this.$message.success("发布成功");
                this.showEditBtn = false
                this.handleGetNeedList()
                this.handleType = 'edit'
                this.showResult = true
                this.handleResetForm()
                sessionStorage.setItem('need_id', '')
                sessionStorage.setItem('unReleaseNeedId', '')
              } else {
                this.unReleaseNeedId = data.need_id
                this.dialogVisible = true
                sessionStorage.setItem('unReleaseNeedId', this.unReleaseNeedId)
              }
            }
            else {
              this.$message.error(msg);
            }
          });
        }
      });
    },
    /**
     * 需求详情
     * @param {*} need_id
     * @return {*}
     */
    handleGetNeedInfo (need_id) {
      this.$post(`/ajaxApi/index.php?s=Client.IntentClient.NeedInfo`, { need_id }, (data, status, msg) => {
        if (status) {
          this.ruleForm = {
            imgs: data.imgs,
            is_design: data.is_design,
            is_survey_sample: data.is_survey_sample,
            name: data.name,
            describe: data.describe,
            num: data.num
          }
          // 登录状态下才允许做修改操作
          if (this.isLogin) {
            this.ruleForm.need_id = data.id
          }
        }
        else {
          this.$message.error(msg);
        }
      });
    }

  }
}
</script>
<style>
.el-button:hover {}

.confirm-btn {
  color: #FFF;
  background-color: #409EFF;
  border-color: #409EFF;
}

.release_need .banner {
  position: relative;
  background: #FFFFFF;
  border-radius: 8px;
  padding: 90px 0 80px;
  text-align: center;
  display: flex;
  flex-flow: column;
  align-items: center;
}

.banner .banner-title {
  position: relative;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: #333333;
  margin: 0 auto;
  z-index: 8;
}

.banner .banner-title::after {
  position: absolute;
  content: '';
  height: 12px;
  background: #FCAE07;
  opacity: 0.2;
  left: 0;
  right: 0;
  bottom: -3px;
  z-index: 7;
}

.banner .banner-bg {
  position: absolute;
  background-size: 100% 100%;
  z-index: 6;
}

.banner .banner-bg.top {
  left: 0;
  top: 0;
  width: 169px;
  height: 325px;
  background-image: url(../assets/images/form-bg-01.png);
}

.banner .banner-bg.bot {
  right: -0;
  bottom: -0;
  width: 237px;
  height: 147px;
  background-image: url(../assets/images/banner-bg-02.png);
}

.banner .step-list {
  display: flex;
  align-items: center;
  width: 90%;
  justify-content: space-around;
  margin-top: 60px;
  /* margin-top: 60px;
  margin: 60px 10% 0; */
}

.step-list .step {
  display: flex;
  text-align: left;
}

.step .step-title {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}

.step .step-desc {
  font-size: 16px;
  font-weight: 400;
  color: #666666;
}

.step-list .arrow {
  width: 15px;
  height: 24px;
  background: url(../assets/images/step-arrow.png);
  background-size: 100% 100%;
}

.main {
  display: flex;
  margin-top: 20px;
  overflow: hidden;
}

.main .slide {
  width: 250px;
  background: #FFFFFF;
  border-radius: 8px;
  max-height: 300px;
  margin-right: 20px;
  flex-shrink: 0;
}

.main .content {
  flex: 1;
  overflow: hidden;
  min-height: 700px;
}

.slide .slide-button {
  margin: 30px 40px;
  background-color: rgba(252, 195, 7, 0.1);
  border-radius: 22px;
  font-size: 16px;
  font-weight: bold;
  color: #FCAE07;
  text-align: center;
  height: 44px;
  line-height: 44px;
  cursor: pointer;
}

.slide-nav {
  margin-top: 26px;
}

.slide-nav .slide-nav-item {
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  padding-left: 30px;
  border-left: 3px solid transparent;
  cursor: pointer;
}

.slide-nav .slide-nav-active {
  background-color: rgba(255, 102, 0, 0.06);
  border-color: #FCAE07;
  font-weight: bold;
  color: #FCAE07;
}

.form-item-detail {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
}

.release-success {
  padding: 60px 0;
  text-align: center;
}

.release-success img {
  margin: 0 auto;
}

.release-success .title {
  font-size: 24px;
  font-weight: bold;
  color: #444444;
  margin-bottom: 10px;
}

.release-success p {
  font-size: 16px;
  font-weight: 400;
  color: #666666;
}

.ls-dialog .el-dialog__header {
  text-align: left;
  border-bottom: 1px solid #E8E9E9;
  ;

}

.ls-dialog .el-dialog__title {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}

.ls-dialog .el-dialog__body {
  padding: 10px;
}

.ls-dialog .tips-img {
  margin: 0 auto;
}

.ls-dialog .tips-text {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-top: 10px;
}

.ls-dialog .el-dialog__footer {
  padding: 20px 10px;
}

.ls-dialog .el-dialog__footer .el-button {
  background: #FFB508;
  border-radius: 19px;
  border-color: transparent;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FFFFFF;
}

.ls-dialog .el-dialog__footer .el-button:last-child {
  background: rgba(255, 181, 8, 0.1);
  border-color: #FFB508;
  color: #FFB508;
}

@media (max-width: 768px) {
  .main {
    flex-direction: column;
  }

  .main .slide {
    width: 100%;
    margin-bottom: 20px;
  }

  .slide .slide-nav {
    margin-top: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/release_need.vue